import { MessengerV2 } from 'lib-shared-legacy-types';

import { dixaMessengerApi } from 'assets/components/settings/components/sections/dixaMessenger/api/apiProvider';
import { MessengerSortKey } from 'assets/components/settings/components/sections/dixaMessenger/api/dixaMessengersApi';
import { usePaginatedEndpoint } from 'hooks/usePaginatedEndpoint';
import {
  InitialParams,
  StandardParams,
  UsePaginatedEndpointResult,
} from 'hooks/usePaginatedEndpoint/types';

type Params = StandardParams<MessengerSortKey>;

export const useMessengers = (
  initialParams: InitialParams<MessengerSortKey, Params>,
): UsePaginatedEndpointResult<MessengerV2, MessengerSortKey, Params> =>
  usePaginatedEndpoint<
    MessengerV2,
    { messengers: MessengerV2[] },
    MessengerSortKey,
    Params
  >({
    endpoint: dixaMessengerApi.fetchAll,
    itemsSelector: (response) => response.messengers,
    initialParams: { sortKey: null, ...initialParams },
  });
